export const getInitSaleTeamsParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-maker_date",
    columnFilter: {},
    keywords: "",
    expand: "maker,checker,hub",
    run: false,
  };
};

export const saleTeamsRecordStatus = [
  {
    key: "O",
    label: "Kích hoạt",
    badgeColor: "success",
  },
  {
    key: "C",
    label: "Ngừng kích hoạt",
    badgeColor: "danger",
  },
];
export const saleTeamsTypeOptions = [
  {
    key: 1,
    label: "Trả kết quả khách hàng lẻ",
  },
  {
    key: 2,
    label: "Không trả kết quả khách hàng lẻ",
  },
];
export const saleTeamsHubOptions = [
  {
    key: "Hà Nội",
    label: "Hà Nội",
  },
  {
    key: "Hồ Chí Minh",
    label: "Hồ Chí Minh",
  },
  {
    key: "Unconfigured",
    label: "Chưa được cấu hình",
  },
];
export const saleTeamsRecordStatusMode = {
  ACTIVE: "O",
  INACTIVE: "C",
};
export const SALE_TEAM_TYPE = {
  TYPE_RETURN: 1,
  TYPE_NO_RETURN: 2,
};
